/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  DeferredIncomeHistoryFundDto,
  DeferredIncomeHistoryFundDtoFromJSON,
  DeferredIncomeHistoryFundDtoFromJSONTyped,
  DeferredIncomeHistoryFundDtoToJSON,
} from "./DeferredIncomeHistoryFundDto";
import {
  DeferredIncomeHistoryLoanDtoFromFund,
  DeferredIncomeHistoryLoanDtoFromFundFromJSON,
  DeferredIncomeHistoryLoanDtoFromFundFromJSONTyped,
  DeferredIncomeHistoryLoanDtoFromFundToJSON,
} from "./DeferredIncomeHistoryLoanDtoFromFund";
import {
  FundHistoryLoanDtoFromDeferredIncome,
  FundHistoryLoanDtoFromDeferredIncomeFromJSON,
  FundHistoryLoanDtoFromDeferredIncomeFromJSONTyped,
  FundHistoryLoanDtoFromDeferredIncomeToJSON,
} from "./FundHistoryLoanDtoFromDeferredIncome";

/**
 *
 * @export
 * @interface DeferredIncomeHistoryDtoLoan
 */
export interface DeferredIncomeHistoryDtoLoan {
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeHistoryDtoLoan
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof DeferredIncomeHistoryDtoLoan
   */
  number: number;
  /**
   *
   * @type {Date}
   * @memberof DeferredIncomeHistoryDtoLoan
   */
  createdAt: Date;
  /**
   *
   * @type {FundHistoryLoanDtoFromDeferredIncome}
   * @memberof DeferredIncomeHistoryDtoLoan
   */
  fromDeferredIncome: FundHistoryLoanDtoFromDeferredIncome | null;
  /**
   *
   * @type {DeferredIncomeHistoryLoanDtoFromFund}
   * @memberof DeferredIncomeHistoryDtoLoan
   */
  fromFund: DeferredIncomeHistoryLoanDtoFromFund | null;
  /**
   *
   * @type {DeferredIncomeHistoryFundDto}
   * @memberof DeferredIncomeHistoryDtoLoan
   */
  toFund: DeferredIncomeHistoryFundDto;
  /**
   *
   * @type {Date}
   * @memberof DeferredIncomeHistoryDtoLoan
   */
  returnAt: Date;
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeHistoryDtoLoan
   */
  comment: string;
}

export function DeferredIncomeHistoryDtoLoanFromJSON(json: any): DeferredIncomeHistoryDtoLoan {
  return DeferredIncomeHistoryDtoLoanFromJSONTyped(json, false);
}

export function DeferredIncomeHistoryDtoLoanFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeferredIncomeHistoryDtoLoan {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    number: json["number"],
    createdAt: new Date(json["createdAt"]),
    fromDeferredIncome: FundHistoryLoanDtoFromDeferredIncomeFromJSON(json["fromDeferredIncome"]),
    fromFund: DeferredIncomeHistoryLoanDtoFromFundFromJSON(json["fromFund"]),
    toFund: DeferredIncomeHistoryFundDtoFromJSON(json["toFund"]),
    returnAt: new Date(json["returnAt"]),
    comment: json["comment"],
  };
}

export function DeferredIncomeHistoryDtoLoanToJSON(value?: DeferredIncomeHistoryDtoLoan | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    number: value.number,
    createdAt: value.createdAt.toISOString(),
    fromDeferredIncome: FundHistoryLoanDtoFromDeferredIncomeToJSON(value.fromDeferredIncome),
    fromFund: DeferredIncomeHistoryLoanDtoFromFundToJSON(value.fromFund),
    toFund: DeferredIncomeHistoryFundDtoToJSON(value.toFund),
    returnAt: value.returnAt.toISOString(),
    comment: value.comment,
  };
}
